import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserPreferenceActions } from "../actions";
import { UserPreferenceService } from '../services/user-preference.service';
import { catchError, concatMap, map, of, switchMap } from "rxjs";
import { ServiceError } from "../../create-request/models/shared/ServiceError";
import { Preference } from "../models/Preference";

@Injectable()
export class UserPreferenceEffects {
  constructor(
    private actions$: Actions,
    private UserPreferenceService: UserPreferenceService,
  ) { }

  callGetUserPreference$ = createEffect(() =>
  this.actions$.pipe(
    ofType(UserPreferenceActions.loadPreferences),
    switchMap(() => {
      return this.UserPreferenceService.getUserPreference().pipe(
        map((userPreferenceResponse: Preference[]) => {
          return UserPreferenceActions.loadPreferencesSuccess({
            userPreferenceResponse
          });
        }),
        catchError((err: ServiceError) =>
          of(UserPreferenceActions.loadPreferencesFailure(err))
        )
      )
    })
  ));

  callSaveUserPreference$ = createEffect(() =>
  this.actions$.pipe(
    ofType(UserPreferenceActions.savePreferences),
    concatMap((action) => {
      return this.UserPreferenceService.saveUserPreference(action.userPreferenceRequest).pipe(
        map((userPreferenceResponse: Preference[]) => {
          return UserPreferenceActions.savePreferencesSuccess({userPreferenceResponse});
        }),
        catchError((err: ServiceError) => of(UserPreferenceActions.savePreferencesFailure(err))
        )
      );
    })
  ));
}
